var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "offset-y": "",
        top: "",
        "content-class": "escopo-select__menu " + _vm.classeDoMenu
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "span",
                {
                  staticClass: "escopo-select__caixa ia-texto-auxiliar",
                  class: {
                    "escopo-select__caixa--so-icone": _vm.soIcone,
                    "escopo-select__caixa--ativo": _vm.cliente,
                    "escopo-select__caixa--travado": _vm.disabled
                  }
                },
                [
                  _c(
                    "button",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "escopo-select__abrir",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled,
                            "aria-label": _vm.tooltipDaCaixa,
                            title: _vm.tooltipDaCaixa
                          },
                          on: { click: _vm.aoClicarNoGatilho }
                        },
                        "button",
                        attrs,
                        false
                      ),
                      _vm.abrirPorFora ? {} : on
                    ),
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "user-2",
                          size: _vm.TAMANHO_ICONE,
                          color: _vm.corDoIcone
                        }
                      }),
                      !_vm.soIcone
                        ? _c("span", { staticClass: "text-truncate" }, [
                            _vm._v(_vm._s(_vm.rotulo))
                          ])
                        : _vm._e(),
                      !_vm.soIcone && !_vm.cliente
                        ? _c("icon-svg", {
                            attrs: {
                              name: "arrow-down-light",
                              size: _vm.TAMANHO_ICONE,
                              color: "var(--neutral-600)"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.mostraAgenteBadge
                    ? _c("AgentBadge", {
                        attrs: {
                          hub: _vm.agente.hub,
                          "agent-slug": _vm.agente.agentSlug || "",
                          motivo: _vm.agente.motivo || "",
                          estado: _vm.estadoDoAgenteBadge
                        }
                      })
                    : _vm._e(),
                  _vm.cliente && !_vm.soIcone
                    ? _c(
                        "button",
                        {
                          staticClass: "escopo-select__remover",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled,
                            title: "Remover o cliente do escopo",
                            "aria-label": "Remover o cliente do escopo"
                          },
                          on: { click: _vm.limpar }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "close-circle",
                              size: _vm.TAMANHO_ICONE,
                              color: _vm.corDoIcone
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.aberto,
        callback: function($$v) {
          _vm.aberto = $$v
        },
        expression: "aberto"
      }
    },
    [
      _c(
        "div",
        {
          ref: "painel",
          staticClass: "escopo-select__painel",
          attrs: { tabindex: "-1" }
        },
        [
          _c("input-by-type", {
            staticClass: "escopo-select__busca",
            attrs: {
              type: "search",
              "max-width": "100%",
              placeholder: "Buscar cliente",
              "aria-label": "Buscar cliente"
            },
            model: {
              value: _vm.busca,
              callback: function($$v) {
                _vm.busca = $$v
              },
              expression: "busca"
            }
          }),
          _c(
            "button",
            {
              staticClass: "ia-sidebar-row escopo-select__opcao",
              attrs: { type: "button" },
              on: { click: _vm.limpar }
            },
            [_vm._v(" Todo o escritório ")]
          ),
          _vm._l(_vm.resultados, function(item) {
            return _c(
              "button",
              {
                key: item.id,
                staticClass: "ia-sidebar-row escopo-select__opcao",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.escolher(item)
                  }
                }
              },
              [
                _c("span", { staticClass: "text-truncate" }, [
                  _vm._v(_vm._s(item.name))
                ])
              ]
            )
          }),
          !_vm.temResultado
            ? _c(
                "p",
                { staticClass: "escopo-select__vazio ia-texto-auxiliar" },
                [_vm._v(" Nenhum cliente encontrado. ")]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }